import { render, staticRenderFns } from "./FactorBaseRevealHeatmap2.vue?vue&type=template&id=6eae977a"
import script from "./FactorBaseRevealHeatmap2.vue?vue&type=script&lang=js"
export * from "./FactorBaseRevealHeatmap2.vue?vue&type=script&lang=js"
import style0 from "./FactorBaseRevealHeatmap2.vue?vue&type=style&index=0&id=6eae977a&lang=css"
import style1 from "./FactorBaseRevealHeatmap2.vue?vue&type=style&index=1&id=6eae977a&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6eae977a')) {
      api.createRecord('6eae977a', component.options)
    } else {
      api.reload('6eae977a', component.options)
    }
    module.hot.accept("./FactorBaseRevealHeatmap2.vue?vue&type=template&id=6eae977a", function () {
      api.rerender('6eae977a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/FactorBaseRevealHeatmap2.vue"
export default component.exports